"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minute = exports.stringifierWithJsonOnlyArgs = exports.sec2ms = exports.ms2sec = exports.jsonDeserialize = exports.jsonSerialize = void 0;
const multi_transaction_1 = require("multi-transaction");
function jsonSerialize(data) {
    return JSON.stringify(data);
}
exports.jsonSerialize = jsonSerialize;
function jsonDeserialize(data) {
    return JSON.parse(data);
}
exports.jsonDeserialize = jsonDeserialize;
function ms2sec(ms) {
    return Math.floor(ms / 1000);
}
exports.ms2sec = ms2sec;
function sec2ms(sec) {
    return sec * 1000;
}
exports.sec2ms = sec2ms;
// Use json only args (object) instead of raw bytes (Buffer) to satisfy OKX wallet
function stringifierWithJsonOnlyArgs() {
    return multi_transaction_1.Stringifier.custom((args) => {
        if (typeof args !== 'object') {
            throw Error('args must be object type');
        }
        return args;
    });
}
exports.stringifierWithJsonOnlyArgs = stringifierWithJsonOnlyArgs;
function minute(n) {
    return n * 60 * 1000;
}
exports.minute = minute;
//# sourceMappingURL=common.js.map